import {
  resolveAct,
  resolveCancel,
  resolveEdge,
  resolveMove,
  resolveRetag,
  resolveRetitle,
  resolveTick,
  resolveUntick,
} from './intent';
import { withPermissions } from './permissions';
import type { Context, Resolution, Stimulus } from './types';

/**
 * **The entry: steps 2 to 6, in order** (docs/RESOLUTION.md §1). One stimulus,
 * one statement: the row of the table (step 4, reading the context of step 2
 * and asking step 3's question where one is due), compiled and folded (step 6),
 * with permissions on top (step 5) - after the intent, never before.
 */

/**
 * Resolve a stimulus into one statement (§1 steps 2 to 6). Pure: a function of
 * (stimulus, context including answers), so the same pair always yields the
 * same plan id, and the executor's determinism check means what it says.
 */
export function resolve(stimulus: Stimulus, context: Context): Resolution {
  switch (stimulus.kind) {
    case 'tick':
      return withPermissions(stimulus, context, resolveTick(stimulus, context));
    case 'untick':
      return withPermissions(stimulus, context, resolveUntick(stimulus, context));
    case 'act':
      return withPermissions(stimulus, context, resolveAct(stimulus, context));
    case 'cancel':
      return withPermissions(stimulus, context, resolveCancel(stimulus, context));
    case 'edge':
      return withPermissions(stimulus, context, resolveEdge(stimulus, context));
    case 'move':
      return withPermissions(stimulus, context, resolveMove(stimulus, context));
    case 'retitle':
      return withPermissions(stimulus, context, resolveRetitle(stimulus, context));
    case 'retag':
      return withPermissions(stimulus, context, resolveRetag(stimulus, context));
  }
}
